import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../../axiosinterceptor";
import { toast } from "react-toastify";
import axios from "axios";
const API_URL = "/coding_support_episode_data";

const initialState = {

// createPatientState-------------

patientCreationState:{
  loading:false,
  error:null,
  success:null,
},
// --------------------


  codingSupportPayload: {
    separation_date_from: null,
    separation_date_to: null,
    admission_date_from: null,
    admission_date_to: null,
    medical_record_number: [],
    speciality: [],
    queue: [],
    priority: [],
    status: [],
    page_number: 1,
    page_size: 10,
    episode_identifier_search: [],
    health_fund_contract: [],
    los: [],
    los_op: "",
    drg_code: [],
    sort_by:[],
    sort_order:[],
    reasons:[],
    is_global_search: false,
    
  },
  // Add these new states for search recommendations
  searchRecommendations: {
    speciality: {
      loading: false,
      data: [],
      error: null,
      searchTerm: "",
      pageNumber: 1,
      hasMore: true,
    },
    medicalRecordNumber: {
      loading: false,
      data: [],
      error: null,
      searchTerm: "",
      hasMore: true,
    },
  },

  codingSupportData: {
    loading: false,
    data: null,
    error: null,
  },
  codingSupportDataCards: {
    loading: false,
    data: null,
    error: null,
  },
  // awaiting CDQs
  awaitingCDQs: {
    loading: false,
    data: [],
    error: null,
  },
  awaitingCDQsCards: {
    loading: false,
    data: [],
    error: null,
  },

  awaitingCDQsPaylaod: {
    page_number: 1,
    separation_date_from: null,
    separation_date_to: null,
    admission_date_from: null,
    admission_date_to: null,
    speciality: [],
    medical_record_number: [],
    queue: [],
    queue_priority: [],
    status: [],
    health_fund_contract: [],
    los: [],
    los_op: "",
    drg: [],
    episode_identifier_search: [],
    sort_by: [],
    sort_order: [],
    is_global_search: false,

  },

  awaitingCDQsAssginModalPayload: {
    hcp_lines: [],
    coder_user_id: null,
    auditor_user_id: null,
    queue_ids: [],
  },

  awaitingCDQsAssginModalResponse: {
  loading: false,
  message: "",
  error: null,
  },
  // -----------------------------------------------------------

  codingSupportStats: {
    loading: false,
    data: [],
    error: null,
  },

  codingSupportQueues: {
    loading: false,
    data: [],
    error: null,
  },
  queueFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  awaitingCDQsQueueFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    // search: "",
  },

  filterOptions: {
    // speciality: { loading: false, data: [], error: null },
    status: { loading: false, data: [], error: null },
    priority: { loading: false, data: [], error: null },
    healthFunds: { loading: false, data: [], error: null },
    queues: { loading: false, data: [], error: null },
    losOptions: { loading: false, data: [], error: null },
    mrnOptions: {
      loading: false,
      data: [],
      error: null,
      pageNumber: 0,
      pageTrue: true,
    },
    episodeIds: {
      loading: false,
      data: [],
      error: null,
      pageNumber: 0,
      pageTrue: true,
    },
  },
  provisionalDrgCodingSupportOptions: {
    provisionalDrgPageNumber: 0,
    provisionalDrgData: [],
    provisionalDrgLoading: false,
    provisionalDrgError: null,
    isprovisionalDrgPageTrue: true,
  },
};

export const setSpecialityPageNumber = (pageNumber) => ({
  type: "codingSupport/setSpecialityPageNumber",
  payload: pageNumber,
});

export const setSpecialityHasMore = (hasMore) => ({
  type: "codingSupport/setSpecialityHasMore",
  payload: hasMore,
});

// In your Redux/codingSupportSlicer.js

// Update the getSpecialityRecommendations action
export const createPatientEpisode = createAsyncThunk("codeWorkflow/createPatientEpisode",async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/create_episode",payload);

      return response?.data
    } catch (error) {
      console.error("Error fetching speciality recommendations:", error);
      return rejectWithValue(
        error.response?.data || "Failed to create episode",
      );
    }
  },)


export const getSpecialityRecommendations = createAsyncThunk(
  "codingSupport/getSpecialityRecommendations",
  async ({ searchTerm, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/CodingSupportSpecialitySearchFilter`,
        {
          params: {
            search: searchTerm,
            page: page,
            limit: limit,
          },
        },
      );

      return {
        data: response.data.data || [],
        page: page,
        hasMore: (response.data.data || []).length === limit,
        searchTerm: searchTerm,
      };
    } catch (error) {
      console.error("Error fetching speciality recommendations:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch speciality options",
      );
    }
  },
);

export const getMedicalRecordNumberRecommendations = createAsyncThunk(
  "codingSupport/getMedicalRecordNumberRecommendations",
  async ({ searchTerm, page = 1, limit = 5 }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/CodingSupportMRNSearchFilter`,
        {
          params: {
            search: searchTerm,
            page: page,
            limit: limit,
          },
        },
      );

      // Extract MRN strings from the response
      const mrnData = (response.data.data || []).map(
        (item) => item.medical_record_number,
      );

      return {
        data: mrnData,
        page: page,
        hasMore: (response.data.data || []).length === limit,
        searchTerm: searchTerm,
      };
    } catch (error) {
      console.error("Error fetching MRN recommendations:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch MRN options",
      );
    }
  },
);

// Add this thunk for priority and status options
export const getPriorityStatusOptions = createAsyncThunk(
  "codingSupport/getPriorityStatusOptions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/CodingSupportGetFilters");
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || "API Error",
      );
    }
  },
);

// In your codingSupportSlicer.js, add these actions:

// Get Queue Options
export const getQueueOptions = createAsyncThunk(
  "codingSupport/getQueueOptions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/CodingSupportQueue");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getQueueFilterOptions = createAsyncThunk(
  "/getQueueFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/coding_support_queue_filters_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching queue options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getAwaitingCDQsQueueFilterOptions = createAsyncThunk(
  "/getAwaitingCDQsQueueFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    console.log(payload, 'payload')
    try {
      const response = await axiosInstance.get(
        "/him_dashboard_get_filters_coding_manager_screen_queue",
        {
          params: {
            page_number: payload.page_number,
          },
        }
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching queue options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

// Get Health Fund Contract Options
export const getHealthFundOptions = createAsyncThunk(
  "codingSupport/getHealthFundOptions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/CodingSupportHealthFundContract",
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchCodingSupport = createAsyncThunk(
  "codingSupport/fetch",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(API_URL, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || "API Error",
      );
    }
  },
);

export const fetchCodingSupportcards = createAsyncThunk(
  "fetchCodingSupportcards",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/coding_support_cards_data", payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || "API Error",
      );
    }
  },
);


export const fetchAwaitingCDQs = createAsyncThunk(
  "fetchAwaitingCDQs/fetch",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/coding_support_awaiting_cdq",
        payload,
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || "API Error",
      );
    }
  },
);

export const fetchCodingSupportQueues = createAsyncThunk(
  "fetchCodingSupportQueues/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get(
        "/coding_support_stats_queue_data"
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || "API Error",
      );
    }
  },
);

export const removeMissingNotes = createAsyncThunk(
  "codingSupport/removeMissingNotes",
  async (hcpLineIds, { rejectWithValue }) => {
    console.log(hcpLineIds, "hcp Line IDs");
    try {
      const res = await axiosInstance.post("/hcp_line_missing_note_remove", {
        hcp_line_id: hcpLineIds,
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  },
);

export const removeAwaitingCdqs = createAsyncThunk(
  "codingSupport/removeAwaitingCdqs",
  async (hcpLineIds, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/coding_support_awaiting_cdq_assign", {
        hcp_line_id: hcpLineIds,
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  },
);
export const getCodingSupportProvisionalDrgData = createAsyncThunk(
  "/getCodingSupportProvisionalDrgData",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    // console.log(payload, 'payload')
    try {
      const response = await axiosInstance.post(
        "/drg_filter_options_acs",
        payload,
      );
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("Error Assigning episodes:", error);
      return rejectWithValue(
        error.response?.data || error.message || "No data found",
      );
      // throw error;
    }
  },
);
export const mRnOptions = createAsyncThunk(
  "/mRnOptions",
  async (
    { search = "", page_number = 1, page_size = 10 },
    { fulfillWithValue, rejectWithValue },
  ) => {
    try {
      const payload = {
        search,
        page_number,
        page_size,
      };

      const response = await axiosInstance.post(
        "/mrn_filter_options_acs",
        payload,
      );

      console.log(response, "response");

      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching health fund options:", error);

      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);
export const getCodingSupportEpisodeIds = createAsyncThunk(
  "/getCodingSupportEpisodeIds",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    // console.log(payload, 'payload')
    try {
      const response = await axiosInstance.post(
        "/episode_identifier_options_acs",
        payload,
      );
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("Error Assigning episodes:", error);
      return rejectWithValue(
        error.response?.data || error.message || "No data found",
      );
      // throw error;
    }
  },
);

export const awaitingCDQsAssginModalAPI = createAsyncThunk(
  "/awaitingCDQsAssginModalAPI",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/coding_support_episode_assignment",
        payload,
      );
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("Error Re-assigning CDQ episode:", error);
      return rejectWithValue(
        error.response?.data || error.message || "No data found",
      );
    }
  },
);

// episode_assignment_coding_support
/* =========================
   SLICE
========================= */
const codingSupportSlice = createSlice({
  name: "codingSupport",
  initialState,
  reducers: {
    updateCodingSupportFilters: (state, action) => {
      // state.codingSupportPayload = {
      //   ...state.codingSupportPayload,
      //   ...action.payload
      // };
      const payload = action.payload;

      // Special handling for LOS to ensure it's a number array
      if (payload.los !== undefined) {
        if (Array.isArray(payload.los)) {
          // Convert string numbers to actual numbers if needed
          payload.los = payload.los.map((item) => {
            const num = parseInt(item);
            return isNaN(num) ? item : num;
          });
        }
      }

      state.codingSupportPayload = {
        ...state.codingSupportPayload,
        ...payload,
      };
    },
    updateAwaitingCDQsFilters: (state, action) => {
      const payload = action.payload;
      if (payload.los !== undefined) {
        if (Array.isArray(payload.los)) {
          payload.los = payload.los.map((item) => {
            const num = parseInt(item);
            return isNaN(num) ? item : num;
          });
        }
      }

      state.awaitingCDQsPaylaod = {
        ...state.awaitingCDQsPaylaod,
        ...payload,
      };
    },
    resetCodingSupportFilters: (state) => {
      state.codingSupportPayload = initialState.codingSupportPayload;
      state.searchRecommendations = initialState.searchRecommendations;
    },
    resetAwaitingCDQsFilters: (state) => {
      state.awaitingCDQsPaylaod = initialState.awaitingCDQsPaylaod;
      state.searchRecommendations = initialState.searchRecommendations;
    },
    updateCodingSupportPage: (state, action) => {
      state.codingSupportPayload.page_number = action.payload;
    },
    updateSpecialitySearchTerm: (state, action) => {
      state.searchRecommendations.speciality.searchTerm = action.payload;
    },
    updateMedicalRecordNumberSearchTerm: (state, action) => {
      state.searchRecommendations.medicalRecordNumber.searchTerm =
        action.payload;
    },
    clearSpecialityRecommendations: (state) => {
      state.searchRecommendations.speciality.data = [];
      state.searchRecommendations.speciality.searchTerm = "";
      state.searchRecommendations.speciality.hasMore = true;
    },
    clearMedicalRecordNumberRecommendations: (state) => {
      state.searchRecommendations.medicalRecordNumber.data = [];
      state.searchRecommendations.medicalRecordNumber.searchTerm = "";
    },
    setSpecialityRecommendations: (state, action) => {
      state.searchRecommendations.speciality.data = action.payload;
      state.searchRecommendations.speciality.loading = false;
      state.searchRecommendations.medicalRecordNumber.hasMore = true;
    },
    appendSpecialityRecommendations: (state, action) => {
      state.searchRecommendations.speciality.data = [
        ...state.searchRecommendations.speciality.data,
        ...action.payload,
      ];
      state.searchRecommendations.speciality.loading = false;
    },
    setSpecialityPageNumber: (state, action) => {
      state.searchRecommendations.speciality.pageNumber = action.payload;
    },
    setSpecialityHasMore: (state, action) => {
      state.searchRecommendations.speciality.hasMore = action.payload;
    },
    resetCodingSupportProvisionalDrg(state) {
      state.provisionalDrgCodingSupportOptions = {
        provisionalDrgPageNumber: 0,
        provisionalDrgData: [],
        provisionalDrgLoading: false,
        provisionalDrgError: null,
        isprovisionalDrgPageTrue: true,
      };
    },
    setQueueFilterSearch: (state, action) => {
      state.queueFilterOptions.search = action.payload;
    },
    setAwaitingCDQsQueueFilterSearch: (state, action) => {
      state.awaitingCDQsQueueFilterOptions.search = action.payload;
    },
    setAwaitingCDQsAssginModalPayload: (state, action) => {
      state.awaitingCDQsAssginModalPayload = {
        ...state.awaitingCDQsAssginModalPayload,
        ...action.payload,
      };
    },
    resetAwaitingCDQsAssginModalPayload: (state, action) => {
      state.awaitingCDQsAssginModalPayload = {
        hcp_lines: [],
        coder_user_id: null,
        auditor_user_id: null,
        queue_ids: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCodingSupport.pending, (state) => {
        state.codingSupportData.loading = true;
        // state.codingSupportQueues.loading = true;
        state.codingSupportStats.loading = true;
      })

      .addCase(fetchCodingSupport.fulfilled, (state, action) => {
        const data = action.payload;

        //table
        state.codingSupportData.loading = false;
        state.codingSupportData.data = data;

        // queues
        // if (data?.queues) {
        //   state.codingSupportQueues.loading = false;
        //   state.codingSupportQueues.data = data.queues;
        // }

        // stats
        if (data?.cards) {
          state.codingSupportStats.loading = false;
          state.codingSupportStats.data = data.cards;
        }
      })

      .addCase(fetchCodingSupport.rejected, (state, action) => {
        state.codingSupportData.loading = false;
        // state.codingSupportQueues.loading = false;
        state.codingSupportStats.loading = false;

        state.codingSupportData.error = action.payload;
        // state.codingSupportQueues.error = action.payload;
        state.codingSupportStats.error = action.payload;
      })
      // cards
      .addCase(fetchCodingSupportcards.pending, (state) => {
        state.codingSupportDataCards.loading = true;
        state.codingSupportDataCards.error = null;
      })
      .addCase(fetchCodingSupportcards.fulfilled, (state, action) => {
        const data = action.payload;
        state.codingSupportDataCards.loading = false;
        state.codingSupportDataCards.data = data;
      })
      .addCase(fetchCodingSupportcards.rejected, (state, action) => {
        state.codingSupportDataCards.loading = false;
        state.codingSupportDataCards.error = action.payload;
      })
      
      .addCase(fetchAwaitingCDQs.pending, (state) => {
        state.awaitingCDQs.loading = true;
        state.awaitingCDQs.error = null;
      })
      .addCase(fetchAwaitingCDQs.fulfilled, (state, action) => {
        const data = action.payload;
        state.awaitingCDQs.loading = false;
        state.awaitingCDQs.data = data;
      })
      .addCase(fetchAwaitingCDQs.rejected, (state, action) => {
        state.awaitingCDQs.loading = false;
        state.awaitingCDQs.error = action.payload;
      })
      .addCase(fetchCodingSupportQueues.pending, (state) => {
        state.codingSupportQueues.loading = true;
        state.codingSupportQueues.error = null;
      })
      .addCase(fetchCodingSupportQueues.fulfilled, (state, action) => {
        const data = action.payload;
        state.codingSupportQueues.loading = false;
        state.codingSupportQueues.data = data;
      })
      .addCase(fetchCodingSupportQueues.rejected, (state, action) => {
        state.codingSupportQueues.loading = false;
        state.codingSupportQueues.error = action.payload;
      })
      // Speciality recommendations
      .addCase(getSpecialityRecommendations.pending, (state) => {
        state.searchRecommendations.speciality.loading = true;
        state.searchRecommendations.speciality.error = null;
      })
      .addCase(getSpecialityRecommendations.fulfilled, (state, action) => {
        // state.searchRecommendations.speciality.loading = false;
        // state.searchRecommendations.speciality.data = action.payload;
        state.searchRecommendations.speciality.loading = false;

        const { data, page, hasMore, searchTerm } = action.payload;

        if (page === 1) {
          // Replace data for first page
          state.searchRecommendations.speciality.data = data;
        } else {
          // Append data for subsequent pages
          state.searchRecommendations.speciality.data = [
            ...state.searchRecommendations.speciality.data,
            ...data,
          ];
        }

        state.searchRecommendations.speciality.pageNumber = page;
        state.searchRecommendations.speciality.hasMore = hasMore;
        state.searchRecommendations.speciality.searchTerm = searchTerm;
      })
      .addCase(getSpecialityRecommendations.rejected, (state, action) => {
        state.searchRecommendations.speciality.loading = false;
        state.searchRecommendations.speciality.error = action.payload;
        state.searchRecommendations.speciality.data = [];
      })

      // Medical Record Number recommendations
      .addCase(getMedicalRecordNumberRecommendations.pending, (state) => {
        state.searchRecommendations.medicalRecordNumber.loading = true;
        state.searchRecommendations.medicalRecordNumber.error = null;
      })
      .addCase(
        getMedicalRecordNumberRecommendations.fulfilled,
        (state, action) => {
          // state.searchRecommendations.medicalRecordNumber.loading = false;
          // state.searchRecommendations.medicalRecordNumber.data = action.payload;
          state.searchRecommendations.medicalRecordNumber.loading = false;

          const { data, page, hasMore, searchTerm } = action.payload;

          if (page === 1) {
            // Replace data for first page
            state.searchRecommendations.medicalRecordNumber.data = data;
          } else {
            // Append data for subsequent pages
            state.searchRecommendations.medicalRecordNumber.data = [
              ...state.searchRecommendations.medicalRecordNumber.data,
              ...data,
            ];
          }
          state.searchRecommendations.medicalRecordNumber.pageNumber = page;
          state.searchRecommendations.medicalRecordNumber.hasMore = hasMore;
          state.searchRecommendations.medicalRecordNumber.searchTerm =
            searchTerm;
        },
      )
      .addCase(
        getMedicalRecordNumberRecommendations.rejected,
        (state, action) => {
          state.searchRecommendations.medicalRecordNumber.loading = false;
          state.searchRecommendations.medicalRecordNumber.error =
            action.payload;
          state.searchRecommendations.medicalRecordNumber.data = [];
        },
      )

      // Priority and Status options
      .addCase(getPriorityStatusOptions.pending, (state) => {
        // Set loading state for both priority and status
        state.filterOptions.priority.loading = true;
        state.filterOptions.status.loading = true;
        state.filterOptions.priority.error = null;
        state.filterOptions.status.error = null;
      })
      .addCase(getPriorityStatusOptions.fulfilled, (state, action) => {
        state.filterOptions.priority.loading = false;
        state.filterOptions.status.loading = false;
        state.filterOptions.priority.data = action.payload.priority || [];
        state.filterOptions.status.data = action.payload.status || [];
      })
      .addCase(getPriorityStatusOptions.rejected, (state, action) => {
        state.filterOptions.priority.loading = false;
        state.filterOptions.status.loading = false;
        state.filterOptions.priority.error = action.payload;
        state.filterOptions.status.error = action.payload;
      })
      // Queue Options
      // .addCase(getQueueOptions.pending, (state) => {
      //   state.filterOptions.queues.loading = true;
      // })
      // .addCase(getQueueOptions.fulfilled, (state, action) => {
      //   state.filterOptions.queues.data =
      //     action.payload.coding_support_queues || [];
      //   state.filterOptions.queues.loading = false;
      // })
      // .addCase(getQueueOptions.rejected, (state) => {
      //   state.filterOptions.queues.loading = false;
      //   // Optional: Set error state
      // })
      .addCase(getQueueFilterOptions.pending, (state) => {
        state.queueFilterOptions.loading = true;
        state.queueFilterOptions.error = null;
      })
      .addCase(getQueueFilterOptions.fulfilled, (state, action) => {
        state.queueFilterOptions.loading = false;
        const newQueues = action.payload?.queues?.queues || [];
        // console.log(newQueues, 'newQueuescoding support', action.payload)
        if (action.payload?.queues?.page_number === 1) {
          state.queueFilterOptions.data = newQueues;
        } else {
          state.queueFilterOptions.data = [
            ...state.queueFilterOptions.data,
            ...newQueues,
          ];
        }
        const isValidPage = action.payload?.has_more ?? false;
        state.queueFilterOptions.hasMore = isValidPage;
        state.queueFilterOptions.pageNumber =
          action.payload?.queues?.page_number;
      })
      .addCase(getQueueFilterOptions.rejected, (state, action) => {
        state.queueFilterOptions.loading = false;
        state.queueFilterOptions.hasMore = false;
        state.queueFilterOptions.error = action.payload;
      })
      // awaiting CDQs Queue options
      .addCase(getAwaitingCDQsQueueFilterOptions.pending, (state) => {
        state.awaitingCDQsQueueFilterOptions.loading = true;
        state.awaitingCDQsQueueFilterOptions.error = null;
      })
      .addCase(getAwaitingCDQsQueueFilterOptions.fulfilled, (state, action) => {
  state.awaitingCDQsQueueFilterOptions.loading = false;

  const newQueues = action.payload?.queues?.queues || [];

  state.awaitingCDQsQueueFilterOptions.data = [
    ...state.awaitingCDQsQueueFilterOptions.data,
    ...newQueues,
  ];

  state.awaitingCDQsQueueFilterOptions.hasMore =
    action.payload?.queues?.queue_name_still_available ?? false;

  state.awaitingCDQsQueueFilterOptions.pageNumber += 1;
})
      .addCase(getAwaitingCDQsQueueFilterOptions.rejected, (state, action) => {
        state.awaitingCDQsQueueFilterOptions.loading = false;
        state.awaitingCDQsQueueFilterOptions.hasMore = false;
        state.awaitingCDQsQueueFilterOptions.error = action.payload;
      })

      // Health Fund Options
      .addCase(getHealthFundOptions.pending, (state) => {
        state.filterOptions.healthFunds.loading = true;
      })
      .addCase(getHealthFundOptions.fulfilled, (state, action) => {
        state.filterOptions.healthFunds.data =
          action.payload.health_fund_contracts || [];
        state.filterOptions.healthFunds.loading = false;
      })
      .addCase(getHealthFundOptions.rejected, (state) => {
        state.filterOptions.healthFunds.loading = false;
        // Optional: Set error state
      })
      //drg options
      .addCase(getCodingSupportProvisionalDrgData.pending, (state) => {
        state.provisionalDrgCodingSupportOptions.provisionalDrgLoading = true;
        state.provisionalDrgCodingSupportOptions.provisionalDrgError = null;
      })
      .addCase(
        getCodingSupportProvisionalDrgData.fulfilled,
        (state, action) => {
          state.provisionalDrgCodingSupportOptions.provisionalDrgLoading = false;

          const { drg_codes = [], has_more } = action.payload;
          const page = action.meta.arg.page_number;

          if (page === 1) {
            state.provisionalDrgCodingSupportOptions.provisionalDrgData =
              drg_codes;
          } else {
            state.provisionalDrgCodingSupportOptions.provisionalDrgData.push(
              ...drg_codes,
            );
          }

          state.provisionalDrgCodingSupportOptions.provisionalDrgPageNumber =
            page;
          state.provisionalDrgCodingSupportOptions.isprovisionalDrgPageTrue =
            has_more;
        },
      )
      .addCase(getCodingSupportProvisionalDrgData.rejected, (state, action) => {
        state.provisionalDrgCodingSupportOptions.provisionalDrgLoading = false;
        state.provisionalDrgCodingSupportOptions.provisionalDrgError =
          action.payload;
      })
      //mrnOptions
      .addCase(mRnOptions.pending, (state) => {
        state.filterOptions.mrnOptions.loading = true;
        state.filterOptions.mrnOptions.error = null;
      })
      .addCase(mRnOptions.fulfilled, (state, action) => {
        state.filterOptions.mrnOptions.loading = false;

        const { medical_record_number = [], has_more } = action.payload;
        const page = action.meta.arg.page_number;

        if (page === 1) {
          state.filterOptions.mrnOptions.data = medical_record_number;
        } else {
          state.filterOptions.mrnOptions.data.push(...medical_record_number);
        }

        state.filterOptions.mrnOptions.pageNumber = page;
        state.filterOptions.mrnOptions.pageTrue = has_more;
      })
      .addCase(mRnOptions.rejected, (state, action) => {
        state.filterOptions.mrnOptions.loading = false;
        state.filterOptions.mrnOptions.error = action.payload;
      })
      //episodeIds
      .addCase(getCodingSupportEpisodeIds.pending, (state) => {
        state.filterOptions.episodeIds.loading = true;
        state.filterOptions.episodeIds.error = null;
      })
      .addCase(getCodingSupportEpisodeIds.fulfilled, (state, action) => {
        state.filterOptions.episodeIds.loading = false;

        const { episode_identifier_number = [], has_more } = action.payload;
        const page = action.meta.arg.page_number;

        if (page === 1) {
          state.filterOptions.episodeIds.data = episode_identifier_number;
        } else {
          state.filterOptions.episodeIds.data.push(
            ...episode_identifier_number,
          );
        }

        state.filterOptions.episodeIds.pageNumber = page;
        state.filterOptions.episodeIds.pageTrue = has_more;
      })
      .addCase(getCodingSupportEpisodeIds.rejected, (state, action) => {
        state.filterOptions.episodeIds.loading = false;
        state.filterOptions.episodeIds.error = action.payload;
      }).addCase(awaitingCDQsAssginModalAPI.pending, (state) => {
        state.awaitingCDQsAssginModalResponse.loading = true;
        state.awaitingCDQsAssginModalResponse.error = null;
      })
      .addCase(awaitingCDQsAssginModalAPI.fulfilled, (state, action) => {
        console.log(action, 'action')
        state.awaitingCDQsAssginModalResponse.loading = false;
        state.awaitingCDQsAssginModalResponse.message = action.payload;
      })
      .addCase(awaitingCDQsAssginModalAPI.rejected, (state, action) => {
        state.awaitingCDQsAssginModalResponse.loading = false;
        state.awaitingCDQsAssginModalResponse.error = action.payload;
      })
      .addCase(createPatientEpisode.pending,(state,action)=>{
        state.patientCreationState.loading = true
        state.patientCreationState.error = null
      })
      .addCase(createPatientEpisode.fulfilled,(state,action)=>{
        state.patientCreationState.loading = false
        state.patientCreationState.success = action.payload
        state.patientCreationState.error = null
      })
      .addCase(createPatientEpisode.rejected,(state,action)=>{
        state.patientCreationState.loading = false
        state.patientCreationState.success = null
        state.patientCreationState.error = action.payload
        toast.error(
        action.payload?.message ||
        action.payload?.error ||
        "Something went wrong"
);
      })

  },
});

export const {
  updateCodingSupportFilters,
  updateAwaitingCDQsFilters,
  resetCodingSupportFilters,
  resetAwaitingCDQsFilters,
  updateSpecialitySearchTerm,
  updateMedicalRecordNumberSearchTerm,
  clearSpecialityRecommendations,
  clearMedicalRecordNumberRecommendations,
  setSpecialityRecommendations,
  appendSpecialityRecommendations,
  resetCodingSupportProvisionalDrg,
  setQueueFilterSearch,
  setAwaitingCDQsQueueFilterSearch,
  setAwaitingCDQsAssginModalPayload,
  resetAwaitingCDQsAssginModalPayload,
} = codingSupportSlice.actions;

export default codingSupportSlice.reducer;
